import {
  CssBaseline,
  Typography,
  Container,
  Box,
  Grid,
  Button,
  TextField,
  Link,
  Alert 
} from "@mui/material";
import React, { useState, FC } from 'react';
import { RouteComponentProps } from "react-router-dom";
import axios from "axios";
import { useForm } from "react-hook-form";
import Logo from '../../assets/InFind.png';


type SomeComponentProps = RouteComponentProps;

const topdiv = {
  
    height: "100vh",
    padding: "10px",
    background: "#cceeff"
}

const Register: FC<SomeComponentProps> = ({ history }) => {
    const {
      register,
      handleSubmit,
      watch,
      setValue,
      clearErrors,
      formState: { errors },
    } = useForm();
    const [firstname, setFirstName] = useState("");
    const [lastname, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [cpassword, setCPassword] = useState("");
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const submitData = (data: any) => {
      let params = {
        username: data.firstname +' '+ data.lastname,
        email: data.email,
        password: data.password,
        confirm_password: data.cpassword,
      };
      axios
        .post("http://34.94.96.59:5050/infindbot/signup", params, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          console.log('response', response);
          if(response.data.error){
            setErrorMessage(response.data.error)
          }else{
            setSuccessMessage('Registration successful');

            setTimeout(() => {
              setSuccessMessage('');
              window.location.href = '/demo/infindwebapp/login';
            }, 5000);
          }
        })
        .catch(function (error) {
          console.log(error)
          setErrorMessage('Problem of inserting credentials to database.')
        });
    };
  
    return (
      <div style={topdiv}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            background: '#fff',
            borderRadius: '30px',
            padding:'30px',
          }}
        >
         { <a href="http://infind.ai">
        <img
        height='50px'          
          src={Logo}
          alt="logo"
        />
        </a> }
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          {successMessage && (
          <Alert severity="success">{successMessage}</Alert>
        )}
        {errorMessage && (
          <Alert severity="error">{errorMessage}</Alert>
        )}
          <form autoComplete="off" >
            <Box component="form" noValidate sx={{ mt: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="First Name"
                    autoFocus
                    autoComplete="fname"
                    variant="outlined"
                    id="firstName"
                    {...register("firstname", {
                      required: "First name is required!",
                    })}
                    value={firstname} 
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      clearErrors("firstname");
                      setValue("firstname", e.target.value); 
                    }}
                    error={!!errors.firstname}
                    helperText={(errors.firstname?.message as any) }
                  />
                 
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    id="lastName"
                    label="Last Name"
                    variant="outlined"
                    autoComplete="lname"
                    {...register("lastname", {
                      required: "Last name is required!",
                    })}
                    value={lastname} 
                    onChange={(e) => {
                      setLastName(e.target.value);
                      clearErrors("lastname");
                      setValue("lastname", e.target.value); 
                    }}
                    error={!!errors.lastname}
                    helperText={(errors.lastname?.message as any) }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    variant="outlined"
                    fullWidth
                    id="email"
                    type="email"
                    label="Email Address"
                    {...register("email", {
                      required: "Email is required!",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: "Invalid email address!",
                      },
                    })}
                    autoComplete="email"
                    value={email} 
                
                    onChange={(e) => {
                      setEmail(e.target.value);
                      clearErrors("email");
                      setValue("email", e.target.value); 
                    }}

                    error={!!errors.email}
                    helperText={(errors.email?.message as any) }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    variant="outlined"
                    fullWidth
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    {...register("password", {
                    required: "Password is required!",
                    })}
                    value={password} 
                    onChange={(e) => {
                      setPassword(e.target.value);
                      clearErrors("password");
                      setValue("password", e.target.value); 
                    }}
                    error={!!errors.password}
                    helperText={(errors.password?.message as any) }
                  />
                </Grid>
                <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Confirm Password"
                  type="password"
                  id="cpassword"
                  autoComplete="current-password"
                  {...register("cpassword", {
                    required: "Confirm Password is required!",
                    validate: (value) =>
                      value === watch("password") ||
                      "Passwords must match!",
                  })}
                  error={!!errors.cpassword}
                  helperText={(errors.cpassword?.message as any) }
                  value={cpassword} 
                  onChange={(e) => {
                      setCPassword(e.target.value);
                      clearErrors("cpassword");
                      setValue("cpassword", e.target.value); 
                  }}
                />
                
              </Grid>
                
              </Grid>
              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleSubmit(submitData)}
              >
                Sign Up
              </Button>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Link href="/demo/infindwebapp/login" variant="body2">
                    Already have an account? Sign in
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Box>
      </Container>
      </div>
    );
  };
  
  export default Register;